<template>
    <div class="container-fluid">
        <div class="row">
            <div class="mt-0">
                <div class="row" id="lower-div">
                    <div class="card mt-4">
                        <div class="p-3">
                            <div class="d-flex align-items-center gap-2 mb-3">
                                <button type="button" @click="NewQuota()" class="btn action-btn action-btn--success">
                                    <i class="bi bi-plus-lg me-1"></i>
                                    <span>Yeni ərizə</span>
                                </button>
                                <button type="button" class="btn action-btn action-btn--muted" @click="GetQuotas()">
                                    <i class="bi bi-arrow-clockwise me-1"></i>
                                    <span>Yeniləmək</span>
                                </button>
                                <button
                                    type="button"
                                    @click="this.showFilter = !this.showFilter"
                                    class="btn action-btn"
                                    :class="this.showFilter ? 'action-btn--info' : 'action-btn--muted'"
                                    title="Filter"
                                >
                                    <i class="bi bi-funnel-fill"></i>
                                </button>
                            </div>
                            <transition name="slide">
                                <div class="row my-3" v-show="this.showFilter">
                                    <div class="col-sm-6 col-md-5 col-lg-4">
                                        <div class="app-search-form-group">
                                            <el-input
                                                v-model="srcText"
                                                placeholder="Tam adı / FİN"
                                                clearable
                                                class="app-search-input"
                                                @keydown.enter="GetQuotas()"
                                            />
                                            <button type="button" @click="GetQuotas()" class="btn app-search-btn">
                                                <i class="bi bi-search"></i>
                                                <span>Axtar</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <div v-loading="loading">
                                <Table :data="data.slice((this.page - 1) * 10, this.page * 10)"
                                    :showFilter="showFilter"></Table>
                                <div style="margin-left: 1%; margin-top: 1%;">
                                    <el-pagination :current-page="this.page"
                                        @current-change="(value) => { page = value }" :page-size="10" background
                                        layout="prev, pager, next" :total="this.data.length" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import dayjs from "dayjs";
import Table from "./Components/Table.vue";
export default {
    components: {
        Table
    },
    data() {
        return {
            srcText: null,
            loading: null,
            page: 1,
            data: [
                {
                    clientId: 1,
                    fullName: "Əli Məmmədov",
                    pin: "78PUYB4",
                    birthDate: "12.03.1985",
                    phone: "+994501112233",
                    email: "ali.mammadov@example.com",
                    address: "Bakı, Nərimanov r.",
                    status: "Aktiv",
                    registrationDate: "01.02.2024",
                    created: "01.02.2024",
                    updated: "15.02.2024"
                },
                {
                    clientId: 2,
                    fullName: "Nigar Quliyeva",
                    pin: "3XQAWZ9",
                    birthDate: "25.07.1990",
                    phone: "+994553334455",
                    email: "nigar.quliyeva@example.com",
                    address: "Sumqayıt, 5-ci mkr",
                    status: "Deaktiv",
                    registrationDate: "10.01.2024",
                    created: "10.01.2024",
                    updated: "20.03.2024"
                },
                {
                    clientId: 3,
                    fullName: "Rauf Hüseynov",
                    pin: "5RTGBH1",
                    birthDate: "09.11.1978",
                    phone: "+994702224466",
                    email: "rauf.huseynov@example.com",
                    address: "Gəncə şəhəri, Nizami k.",
                    status: "Aktiv",
                    registrationDate: "15.02.2024",
                    created: "15.02.2024",
                    updated: "01.03.2024"
                },
                {
                    clientId: 4,
                    fullName: "Sevinc Əliyeva",
                    pin: "7MNBVC3",
                    birthDate: "04.05.1995",
                    phone: "+994557778899",
                    email: "sevinc.aliyeva@example.com",
                    address: "Bakı, Yasamal r.",
                    status: "Aktiv",
                    registrationDate: "20.03.2024",
                    created: "20.03.2024",
                    updated: "25.03.2024"
                },
                {
                    clientId: 5,
                    fullName: "Elvin Qasımov",
                    pin: "1QAZWS6",
                    birthDate: "18.01.1982",
                    phone: "+994505551122",
                    email: "elvin.qasimov@example.com",
                    address: "Bakı, Xətai r.",
                    status: "Deaktiv",
                    registrationDate: "05.02.2024",
                    created: "05.02.2024",
                    updated: "10.02.2024"
                },
                {
                    clientId: 6,
                    fullName: "Aygün Məmmədova",
                    pin: "4EDCRF2",
                    birthDate: "30.09.1988",
                    phone: "+994773339988",
                    email: "aygun.mammadova@example.com",
                    address: "Şəki şəhəri",
                    status: "Aktiv",
                    registrationDate: "07.02.2024",
                    created: "07.02.2024",
                    updated: "12.02.2024"
                },
                {
                    clientId: 7,
                    fullName: "Orxan Həsənov",
                    pin: "6TGBNH8",
                    birthDate: "14.02.1992",
                    phone: "+994709911223",
                    email: "orxan.hesenov@example.com",
                    address: "Bakı, Binəqədi r.",
                    status: "Aktiv",
                    registrationDate: "12.03.2024",
                    created: "12.03.2024",
                    updated: "22.03.2024"
                },
                {
                    clientId: 8,
                    fullName: "Leyla Rzayeva",
                    pin: "2YHNJM5",
                    birthDate: "05.06.1986",
                    phone: "+994554446677",
                    email: "leyla.rzayeva@example.com",
                    address: "Mingəçevir şəhəri",
                    status: "Deaktiv",
                    registrationDate: "18.01.2024",
                    created: "18.01.2024",
                    updated: "28.02.2024"
                },
                {
                    clientId: 9,
                    fullName: "Kamal Məlikov",
                    pin: "8UJMIK0",
                    birthDate: "22.12.1975",
                    phone: "+994507772211",
                    email: "kamal.melikov@example.com",
                    address: "Bakı, Sabunçu r.",
                    status: "Aktiv",
                    registrationDate: "01.03.2024",
                    created: "01.03.2024",
                    updated: "05.03.2024"
                },
                {
                    clientId: 10,
                    fullName: "Zəhra Abdullayeva",
                    pin: "9OLKJI7",
                    birthDate: "19.08.1993",
                    phone: "+994775556677",
                    email: "zehra.abdullayeva@example.com",
                    address: "Quba şəhəri",
                    status: "Aktiv",
                    registrationDate: "02.02.2024",
                    created: "02.02.2024",
                    updated: "12.03.2024"
                },
                {
                    clientId: 11,
                    fullName: "Murad Əliyev",
                    pin: "0POIUY3",
                    birthDate: "07.11.1980",
                    phone: "+994503336699",
                    email: "murad.aliyev@example.com",
                    address: "Bakı, Nəsimi r.",
                    status: "Deaktiv",
                    registrationDate: "11.02.2024",
                    created: "11.02.2024",
                    updated: "20.02.2024"
                },
                {
                    clientId: 12,
                    fullName: "Aysel Hacıyeva",
                    pin: "1QAZXS2",
                    birthDate: "29.04.1991",
                    phone: "+994708811223",
                    email: "aysel.haciyeva@example.com",
                    address: "Lənkəran şəhəri",
                    status: "Aktiv",
                    registrationDate: "16.03.2024",
                    created: "16.03.2024",
                    updated: "21.03.2024"
                },
                {
                    clientId: 13,
                    fullName: "Emin Hümbətov",
                    pin: "3WSXED4",
                    birthDate: "10.10.1987",
                    phone: "+994555221133",
                    email: "emin.humbetov@example.com",
                    address: "Şəmkir şəhəri",
                    status: "Aktiv",
                    registrationDate: "09.02.2024",
                    created: "09.02.2024",
                    updated: "15.02.2024"
                },
                {
                    clientId: 14,
                    fullName: "Şəfa Qasımova",
                    pin: "5RFVTG7",
                    birthDate: "02.01.1996",
                    phone: "+994773345566",
                    email: "shefa.qasimova@example.com",
                    address: "Bakı, Suraxanı r.",
                    status: "Aktiv",
                    registrationDate: "14.03.2024",
                    created: "14.03.2024",
                    updated: "18.03.2024"
                },
                {
                    clientId: 15,
                    fullName: "Cavid İbrahimov",
                    pin: "6TGBNH2",
                    birthDate: "11.11.1984",
                    phone: "+994709922334",
                    email: "cavid.ibrahimov@example.com",
                    address: "Bərdə şəhəri",
                    status: "Deaktiv",
                    registrationDate: "03.01.2024",
                    created: "03.01.2024",
                    updated: "12.01.2024"
                },
                {
                    clientId: 16,
                    fullName: "Xədicə Vəliyeva",
                    pin: "7YHNUJ5",
                    birthDate: "26.02.1989",
                    phone: "+994503320011",
                    email: "xedice.veliyeva@example.com",
                    address: "Bakı, Qaradağ r.",
                    status: "Aktiv",
                    registrationDate: "22.02.2024",
                    created: "22.02.2024",
                    updated: "01.03.2024"
                },
                {
                    clientId: 17,
                    fullName: "Tural Əhmədov",
                    pin: "9IKOLP6",
                    birthDate: "08.07.1983",
                    phone: "+994557733221",
                    email: "tural.ahmedov@example.com",
                    address: "Naftalan şəhəri",
                    status: "Aktiv",
                    registrationDate: "28.02.2024",
                    created: "28.02.2024",
                    updated: "06.03.2024"
                },
                {
                    clientId: 18,
                    fullName: "Lalə Cəfərova",
                    pin: "0QAZWS1",
                    birthDate: "15.05.1994",
                    phone: "+994708822334",
                    email: "lale.ceferova@example.com",
                    address: "Bakı, Xəzər r.",
                    status: "Deaktiv",
                    registrationDate: "06.03.2024",
                    created: "06.03.2024",
                    updated: "10.03.2024"
                },
                {
                    clientId: 19,
                    fullName: "Samir Məmmədli",
                    pin: "2WSXED8",
                    birthDate: "20.09.1979",
                    phone: "+994775566778",
                    email: "samir.mammadli@example.com",
                    address: "Zaqatala şəhəri",
                    status: "Aktiv",
                    registrationDate: "17.02.2024",
                    created: "17.02.2024",
                    updated: "25.02.2024"
                },
                {
                    clientId: 20,
                    fullName: "Günel Əliyeva",
                    pin: "4RFVTG9",
                    birthDate: "03.04.1992",
                    phone: "+994503334455",
                    email: "gunel.aliyeva@example.com",
                    address: "Bakı, Sabail r.",
                    status: "Aktiv",
                    registrationDate: "08.03.2024",
                    created: "08.03.2024",
                    updated: "15.03.2024"
                },
                {
                    clientId: 21,
                    fullName: "Rəşad Quliyev",
                    pin: "6TGBNH0",
                    birthDate: "14.01.1981",
                    phone: "+994503301122",
                    email: "reshad.quliyev@example.com",
                    address: "Bakı, Xətai r.",
                    status: "Aktiv",
                    registrationDate: "10.03.2024",
                    created: "10.03.2024",
                    updated: "20.03.2024"
                },
                {
                    clientId: 22,
                    fullName: "Ülviyyə Abbasova",
                    pin: "1QWERT3",
                    birthDate: "02.09.1995",
                    phone: "+994702229944",
                    email: "ulviyya.abbasova@example.com",
                    address: "Qazax şəhəri",
                    status: "Deaktiv",
                    registrationDate: "07.02.2024",
                    created: "07.02.2024",
                    updated: "15.03.2024"
                },
                {
                    clientId: 23,
                    fullName: "Arif Rüstəmov",
                    pin: "4ASDFG6",
                    birthDate: "23.05.1987",
                    phone: "+994555667788",
                    email: "arif.rustemov@example.com",
                    address: "Bakı, Yasamal r.",
                    status: "Aktiv",
                    registrationDate: "01.04.2024",
                    created: "01.04.2024",
                    updated: "05.04.2024"
                },
                {
                    clientId: 24,
                    fullName: "Könül Əliyeva",
                    pin: "7ZXCVB2",
                    birthDate: "11.07.1990",
                    phone: "+994709900221",
                    email: "konul.aliyeva@example.com",
                    address: "Masallı şəhəri",
                    status: "Aktiv",
                    registrationDate: "15.02.2024",
                    created: "15.02.2024",
                    updated: "25.02.2024"
                },
                {
                    clientId: 25,
                    fullName: "Elşən Məmmədli",
                    pin: "8QAZWS4",
                    birthDate: "09.04.1982",
                    phone: "+994773300112",
                    email: "elsen.mammadli@example.com",
                    address: "Şirvan şəhəri",
                    status: "Deaktiv",
                    registrationDate: "18.01.2024",
                    created: "18.01.2024",
                    updated: "02.02.2024"
                },
                {
                    clientId: 26,
                    fullName: "Gülnar Rəhimova",
                    pin: "3WSXED7",
                    birthDate: "06.06.1996",
                    phone: "+994707744112",
                    email: "gulnar.rehimova@example.com",
                    address: "Bakı, Binəqədi r.",
                    status: "Aktiv",
                    registrationDate: "12.03.2024",
                    created: "12.03.2024",
                    updated: "22.03.2024"
                },
                {
                    clientId: 27,
                    fullName: "Kamran Vəliyev",
                    pin: "5RFVTG8",
                    birthDate: "03.12.1984",
                    phone: "+994555330044",
                    email: "kamran.veliyev@example.com",
                    address: "Tovuz şəhəri",
                    status: "Aktiv",
                    registrationDate: "20.03.2024",
                    created: "20.03.2024",
                    updated: "29.03.2024"
                },
                {
                    clientId: 28,
                    fullName: "Sabina Qasımova",
                    pin: "9TGBNH5",
                    birthDate: "25.08.1993",
                    phone: "+994502223355",
                    email: "sabina.qasimova@example.com",
                    address: "Bakı, Nərimanov r.",
                    status: "Deaktiv",
                    registrationDate: "05.02.2024",
                    created: "05.02.2024",
                    updated: "14.02.2024"
                },
                {
                    clientId: 29,
                    fullName: "Fərid Hüseynov",
                    pin: "0YHNJM1",
                    birthDate: "21.11.1989",
                    phone: "+994704455667",
                    email: "ferid.huseynov@example.com",
                    address: "Xaçmaz şəhəri",
                    status: "Aktiv",
                    registrationDate: "01.02.2024",
                    created: "01.02.2024",
                    updated: "10.03.2024"
                },
                {
                    clientId: 30,
                    fullName: "Aytac Əhmədova",
                    pin: "2UJMIK4",
                    birthDate: "19.10.1991",
                    phone: "+994705599221",
                    email: "aytac.ahmedova@example.com",
                    address: "Bakı, Nəsimi r.",
                    status: "Aktiv",
                    registrationDate: "17.03.2024",
                    created: "17.03.2024",
                    updated: "23.03.2024"
                },
                {
                    clientId: 31,
                    fullName: "Ənvər Məlikov",
                    pin: "6OLKJI3",
                    birthDate: "07.02.1985",
                    phone: "+994778899001",
                    email: "enver.melikov@example.com",
                    address: "İmişli şəhəri",
                    status: "Aktiv",
                    registrationDate: "09.01.2024",
                    created: "09.01.2024",
                    updated: "19.01.2024"
                },
                {
                    clientId: 32,
                    fullName: "Şəbnəm Abbasova",
                    pin: "8POIUY7",
                    birthDate: "30.03.1994",
                    phone: "+994503322556",
                    email: "shebnem.abbasova@example.com",
                    address: "Bakı, Sabunçu r.",
                    status: "Deaktiv",
                    registrationDate: "02.03.2024",
                    created: "02.03.2024",
                    updated: "08.03.2024"
                },
                {
                    clientId: 33,
                    fullName: "Tahir Qasımov",
                    pin: "1QAZED5",
                    birthDate: "15.04.1980",
                    phone: "+994553330077",
                    email: "tahir.qasimov@example.com",
                    address: "Astara şəhəri",
                    status: "Aktiv",
                    registrationDate: "14.02.2024",
                    created: "14.02.2024",
                    updated: "20.02.2024"
                },
                {
                    clientId: 34,
                    fullName: "Nərgiz Rzayeva",
                    pin: "4WSXRF6",
                    birthDate: "12.05.1988",
                    phone: "+994709955331",
                    email: "nergiz.rzayeva@example.com",
                    address: "Bakı, Suraxanı r.",
                    status: "Aktiv",
                    registrationDate: "10.03.2024",
                    created: "10.03.2024",
                    updated: "18.03.2024"
                },
                {
                    clientId: 35,
                    fullName: "Əli Hümbətov",
                    pin: "7EDCRF2",
                    birthDate: "08.09.1977",
                    phone: "+994503344221",
                    email: "eli.humbetov@example.com",
                    address: "Şamaxı şəhəri",
                    status: "Deaktiv",
                    registrationDate: "05.01.2024",
                    created: "05.01.2024",
                    updated: "12.01.2024"
                },
                {
                    clientId: 36,
                    fullName: "Zülfiyyə Məmmədova",
                    pin: "9RFVTG1",
                    birthDate: "27.06.1992",
                    phone: "+994772201133",
                    email: "zulfiye.mammadova@example.com",
                    address: "Bakı, Qaradağ r.",
                    status: "Aktiv",
                    registrationDate: "08.02.2024",
                    created: "08.02.2024",
                    updated: "15.02.2024"
                },
                {
                    clientId: 37,
                    fullName: "Vüqar Abdullayev",
                    pin: "0TGBNH4",
                    birthDate: "17.12.1983",
                    phone: "+994505566778",
                    email: "vuqar.abdullayev@example.com",
                    address: "Salyan şəhəri",
                    status: "Aktiv",
                    registrationDate: "20.03.2024",
                    created: "20.03.2024",
                    updated: "28.03.2024"
                },
                {
                    clientId: 38,
                    fullName: "Sevil Həsənova",
                    pin: "2YHNJM0",
                    birthDate: "29.01.1997",
                    phone: "+994702202233",
                    email: "sevil.hesenova@example.com",
                    address: "Bakı, Yasamal r.",
                    status: "Deaktiv",
                    registrationDate: "07.01.2024",
                    created: "07.01.2024",
                    updated: "15.01.2024"
                },
                {
                    clientId: 39,
                    fullName: "Hikmət Əliyev",
                    pin: "5UJMIK9",
                    birthDate: "04.08.1986",
                    phone: "+994775500221",
                    email: "hikmet.aliyev@example.com",
                    address: "Göyçay şəhəri",
                    status: "Aktiv",
                    registrationDate: "02.02.2024",
                    created: "02.02.2024",
                    updated: "10.02.2024"
                },
                {
                    clientId: 40,
                    fullName: "Rəna Məmmədova",
                    pin: "8OLKJI6",
                    birthDate: "16.11.1990",
                    phone: "+994509922334",
                    email: "rena.mammadova@example.com",
                    address: "Bakı, Nərimanov r.",
                    status: "Aktiv",
                    registrationDate: "12.03.2024",
                    created: "12.03.2024",
                    updated: "20.03.2024"
                },
                {
                    clientId: 41,
                    fullName: "Cəlal Qasımov",
                    pin: "3POIUY8",
                    birthDate: "01.03.1985",
                    phone: "+994507701122",
                    email: "celal.qasimov@example.com",
                    address: "Bakı, Yasamal r.",
                    status: "Aktiv",
                    registrationDate: "05.02.2024",
                    created: "05.02.2024",
                    updated: "12.02.2024"
                }
            ],
            dialogVis: false,
            status: -1,
            date1: new Date(new Date().setFullYear(new Date().getFullYear() - 2)).toISOString().split("T")[0],
            date2: new Date(),
            showFilter: true,
            companyName: null
        }
    },
    methods: {
        DisableStartDate(date) {
            return this.date2 && dayjs(date).isAfter(dayjs(this.date2), 'day')
        },
        DisableEndDate(date) {
            return this.date1 && dayjs(date).isBefore(dayjs(this.date1), 'day')
        },
        NewQuota() {
            window.open(window.location.origin + '/documents/quota', "_blank");
        },
    },
    mounted() {
        this.data.map(client => {
            const randomPin = Math.floor(1000 + Math.random() * 9000); // 4-значный PIN
            return { ...client, pin: randomPin };
        });
    }
}
</script>